import styled from 'styled-components';

import { Button } from '../../components//Button/Button';
import { ButtonSize, ButtonVariant } from '../../components/Button/Button.types';
import {
  Container,
  FONT_WEIGHT,
  Row as Rw,
  TypographyProps,
  fonts,
  textBase,
} from '../../components/Common';
import { LegalLink as AppLegalLink } from '../../components/LegalLink/LegalLink';
import Logo from '../../components/Logo/Logo';
import { Input } from '../../components/atoms';
import { breakpoint } from '../../utils/breakpoint';
import { flexCenter } from '../../utils/styled/mixins';

export const FirstLoadContentContainer = styled(Container)`
  ${flexCenter}
  flex-direction: column;
  min-height: 100vh;
  min-height: 100svh;
`;

export const LinearGradient = styled.div`
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

export const ContentWrapper = styled.div`
  padding-top: 6.25rem;
  display: flex;
  flex: 1;

  ${breakpoint('md')`
    padding-top: 5rem;
  `}

  ${breakpoint('xl')`
    padding-top: 7.5rem;
  `}
`;

export const ContentContainer = styled(Container)`
  z-index: ${({ theme }) => theme.zIndex.content};
  display: grid;
  grid-template-rows: auto auto 1fr;
`;

export const MsgLogo = styled(Logo)`
  width: 12.125rem;
  margin: 0 auto;

  img {
    width: 100%;
  }

  ${breakpoint('md')`
    width: 11rem;
  `}

  ${breakpoint('xl')`
    width: 16.5rem;
  `}
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 1.5rem;
  gap: 1rem;

  ${breakpoint('md')`
    padding-top: 2.5rem;
    gap: 1.25rem;
    flex-direction: row;
  `}

  ${breakpoint('xl')`
    padding-top: 7.5rem;
  `}
`;

export const SubmitButton = styled(Button).attrs({
  size: ButtonSize.Large,
  variant: ButtonVariant.Primary,
})`
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  width: 100%;
`;

export const LegalLink = styled(AppLegalLink)`
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: none;
  font-weight: ${FONT_WEIGHT.Bold};
  font-style: normal;

  &:hover,
  &:active {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const EmailForm = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const EmailLabel = styled.label<TypographyProps>`
  color: ${({ theme }) => theme.colors['pure-white']};
  ${(props) => textBase(props)};

  ${fonts.body1.xl}
  font-weight: ${FONT_WEIGHT.Bold};
  margin-bottom: 1.5rem;
  text-align: center;
`;

export const EmailInput = styled(Input)`
  margin: 0 auto;

  ${breakpoint('xl')`
    max-width: 43rem;
  `}

  ${breakpoint('xxl')`
    max-width: 100%;
  `}
`;

export const LegalCopyTextRow = styled(Rw)`
  margin-top: auto;

  ${breakpoint('md')`
    padding-bottom: 1rem;
  `}

  ${breakpoint('xl')`
    padding-bottom: 0;
  `}
`;

export const LegalCopyText = styled.p`
  color: ${({ theme }) => theme.colors['pure-white']};
  font-size: 1rem;
  line-height: 1.25rem;
  font-weight: ${FONT_WEIGHT.Regular};
  text-align: center;
  margin-bottom: 1.5rem;
`;

export const Row = styled(Rw)`
  margin: 0;

  > div {
    padding: 0;
  }
`;
